export function isCheckboxChecked(value: boolean) {
  return !value ? 'This field is required' : ''
}
